import { snakify } from 'helpers/syntaxHelper';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ScopeTree } from 'routes/HumanResourcesModule/helpers/types';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * Fetch the scope tree of a block.
 * @param {string} blockName - The name of the restriction block
 * @returns {UseQueryResult<ScopeTree>} The scope tree of the block.
 */
export const useFetchScopeTree = (
    blockName: string,
): UseQueryResult<ScopeTree> =>
    useQuery({
        queryKey: ['scopeTree', blockName],

        queryFn: async () => {
            const response = await RQAPICallWithData<ScopeTree>({
                endpoint: `auth/scope_tree/${snakify(blockName)}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
